import { useReducedMotion as useMotionReducedMotion } from 'motion/react';

/**
 * Returns true if the user has requested reduced motion via their OS settings.
 * Use this to disable or simplify animations.
 */
export function useReducedMotion(): boolean {
  return useMotionReducedMotion() ?? false;
}
